import { connect } from 'react-redux'
import { checkBuka } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkBuka
}
const mapStateToProps = (state) => {
  return {
    ...state.BukaCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
